import { Component, OnDestroy } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { BaseController } from '@rensa/shared/base-controller';
import { faCheck } from '@fortawesome/free-solid-svg-icons';
import { ContactStyle } from '@rensa/modules/customer/components/footer/footer.component';
import { ItemService } from '@rensa/modules/customer/services/item.service';
import { ImageService } from '@rensa/modules/customer/services/image.service';
import { ListItem } from '@rensa/modules/customer/models/list-item.model';
import { Event } from '@rensa/modules/customer/models/event.model';
import { Observable } from 'rxjs';
import { ItemType } from '@rensa/shared/enums/item-type.enum';

@Component({
    selector: 'app-list-item-detail',
    templateUrl: './list-item-detail.component.html',
    styleUrls: ['./list-item-detail.component.css'],
})
export class ListItemDetailComponent extends BaseController implements OnDestroy {
    faCheck = faCheck;
    ContactStyle = ContactStyle;
    itemId: string;
    base64headerImage: string | ArrayBuffer;
    base64firstHostCompanyImage: string | ArrayBuffer;
    base64secondHostCompanyImage: string | ArrayBuffer;
    loadImages = ['headerImage', 'firstHostCompanyImage', 'secondHostCompanyImage'];
    item: ListItem;
    itemTypeEnum = ItemType;
    loadingItem = true;
    isPreview = false;

    constructor(private route: ActivatedRoute, private itemService: ItemService, private imageService: ImageService) {
        super();
        this.addSubscription(
            this.route.params.subscribe((next) => {
                this.itemId = next.id;
                this.isPreview = this.route.snapshot.queryParams.preview === 'true';

                const observable: Observable<ListItem> = this.isPreview
                    ? this.itemService.fetchPreview(this.itemId)
                    : this.itemService.fetchBy(this.itemId);

                this.addSubscription(
                    observable.subscribe(
                        (item) => {
                            this.loadingItem = false;
                            this.item = item;
                            this.item.events = this.GetSortedEvents();
                            this.loadImages.forEach((field) => this.setImage(item[field], field));
                        },
                        (error) => {
                            console.error(error);
                            this.loadingItem = false;
                        }
                    )
                );
            })
        );
    }

    ngOnDestroy(): void {
        this._ngOnDestroy();
    }

    setImage(pictureId: string, fieldName: string): void {
        if (!pictureId) {
            return;
        }
        this.imageService
            .fetchBy(pictureId)
            .then((result) => this.blobToImage(result, fieldName))
            .catch((error) => console.error(error));
    }

    private blobToImage(blob: Blob, fieldName: string): void {
        const reader = new FileReader();
        reader.readAsDataURL(blob);
        reader.onloadend = () => (this[`base64${fieldName}`] = reader.result);
    }

    private GetSortedEvents(): Event[] {
        return this.item.events?.sort((prev, curr) => {
            if (prev.startDateTime === curr.startDateTime) {
                return 0;
            } else if (prev.startDateTime === null) {
                return 1;
            } else if (curr.startDateTime === null) {
                return -1;
            }
            return prev.startDateTime < curr.startDateTime ? -1 : 1;
        });
    }
}
